export const formatWithCommas = (value : number | string | null | undefined) : string => {
    if(value === null || value === undefined || value === "") return "";
    const num = Number(value);
    if(isNaN(num)) return "";
    return num.toLocaleString("en-US");
};

export const fomratWithCommasAndDecimals = (value : number | string | null | undefined) : string => {
    if(value === null || value === undefined || value === "") return "";
    const num = Number(value);
    if(isNaN(num)) return "";
    return num.toLocaleString("en-US", {minimumFractionDigits : 2 , maximumFractionDigits : 2});
}